export const VALIDATE = 'QR_SCANNER/validate';

export default {}